<template>
  <div class="form-field-container">
    <label v-if="showLabel" :for="id" class="form-label">{{ label }}</label>
    <div v-if="showRequired" class="required-mark-container">
      <span v-if="required" class="required-mark">必須</span>
    </div>
    <div class="date-container">
      <input 
        type="date" 
        :id="id" 
        :name="id" 
        :class="inputClass" 
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :disabled="disabled"
      />
      <button type="button" class="calendar-button" @click="focusDateInput">
        <i class="fas fa-calendar-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormDateField',
  props: {
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showRequired: {
      type: Boolean,
      default: true
    },
    inputClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    focusDateInput() {
      const dateInput = document.getElementById(this.id);
      if (dateInput) {
        dateInput.showPicker();
      }
    }
  }
}
</script>

<style scoped>
.form-field-container {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 10px 30px;
  margin: 5px;
  border-radius: 4px;
}

.form-label {
  min-width: 180px;
  font-weight: 700;
  flex: 0 0 180px;
}

.required-mark-container {
  width: 40px;
  margin-right: 10px;
  flex-shrink: 0;
}

.required-mark {
  background-color: #ff0000;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  width: 100%;
  text-align: center;
  display: inline-block;
}

.date-container {
  width: 200px; /* Fixed width as requested */
  min-width: 200px; /* Ensure minimum width for the input field */
  position: relative;
  display: flex;
}

input[type="date"] {
  width: 100%;
  padding: 8px;
  border: 2px solid #195983;
  border-radius: 4px;
  box-sizing: border-box;
}

.calendar-button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background-color: #195983;
  border: none;
  color: white;
  width: 40px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  cursor: pointer;
}

.calendar-button:hover {
  background-color: #0d4b6f;
}
</style>
